import { IGuest } from '@bridebook/models/source/models/Weddings/Guests.types';

interface UseMainGuestEmailParams {
  guest: IGuest;
  headGuest?: IGuest;
  currentEmail: string;
}

export const useMainGuestEmail = ({ guest, headGuest, currentEmail }: UseMainGuestEmailParams) => {
  const headGuestEmail = headGuest?.contacts?.email || '';
  const isVisible = !!headGuestEmail && guest.id !== headGuest?.id;
  const isUsingHeadGuestEmail = currentEmail === headGuestEmail;

  return {
    headGuestEmail,
    isVisible,
    isUsingHeadGuestEmail,
  };
};
